<mat-drawer-container class="example-container">
    <mat-drawer mode="side" opened>
        <p class="logoHeader">
            <img src="./../../assets/img/pmb-go.png" class="logoButton">
        </p>
        <span class="dispositiviText">Dispositivi:</span>
        <mat-divider></mat-divider>
        <button mat-button (click)="openSpot(spot)" class="fullWidthButton"
            *ngFor="let spot of spotName; let i = index">
            <mat-icon inline=true class=colorizedIcon>room</mat-icon>
            <span>{{spot}}</span>
        </button>
        <mat-divider class="logoutDivider"></mat-divider>
        <button mat-button (click)="logout()" class="logoutButton">
            <mat-icon inline=true>exit_to_app</mat-icon>
            Logout
        </button>
    </mat-drawer>
    <mat-drawer-content>
        <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>